import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { CommonModule } from '@angular/common';
import { NotificationDetailsService } from '../notification-details.service';

@Component({
  selector: 'dl-deleteAattachment-justification',
  standalone: true,
  imports: [OneWebComponentsAngularModule, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './delete-attachment-justification.component.html',
  styleUrls: ['./delete-attachment-justification.component.scss']
})
export class DeleteAttachmentJustificationComponent implements OnInit {

  @Output() justification = new EventEmitter<any>();
  public addJustification = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);


  constructor(
    private snackBarNotification: SnackbarService,
    private qnsbnservice: QnSbnService,
    private notificationDetailsService: NotificationDetailsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  public saveJustification() {
    let noteText = this.addJustification.value;
    noteText=noteText.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
    if (noteText.length == 0) {
      this.snackBarNotification.snackBarMessage('alarm', 'Justification cannot be empty. You must have to specify the reason for deleting the attachemts.');
    } else if (noteText.length > 50) {
      this.snackBarNotification.snackBarMessage('alarm', 'Justification is too long. Maximum length is 50 characters');
    } else if (noteText.length < 10) {
      this.snackBarNotification.snackBarMessage('alarm', 'Justification is too short. Minimum length is 10 characters');
    } else {
      this.justification.emit(noteText);
      this.addJustification.setValue('');
    }
  }

  cancelClicked() {
    this.justification.emit("");
    this.addJustification.setValue('');
  }

}
